export const SEED_PLANT_TYPES = [
  { id: 2, labelKey: 'cotton' },
  { id: 1, labelKey: 'grain' },
] as const;

/** Faqat paxta bo'yicha ma'lumot beradigan sahifalar uchun (yer maydoni). */
export const COTTON_ONLY_PLANT_TYPES = SEED_PLANT_TYPES.filter(
  ({ labelKey }) => labelKey === 'cotton',
);
